import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { getNewsByTags, getNewsTags } from 'actions/news.action'
import { TranslationKeys } from 'types/TranslationKeys'
import getLanguageFromUrl from 'utils/getLanguageFromUrl'
import ITag from 'models/Common/ITag'

export interface RelatedNewsProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useRelatedNews = (props: RelatedNewsProps) => {
  const dispatch = useAppDispatch()
  const [departmentRelatedTags, setDepartmentRelatedTags] = useState<ITag[]>([])
  const [activeTabId, setActiveTabId] = useState<string | null>(null)

  const departmentDetails = useSelector(
    (state: RootState) => state.department.departmentDetails
  )
  const newsTags = useSelector((state: RootState) => state.news.newsTags)
  const newsByTags = useSelector((state: RootState) => state.news.newsByTags)
  const selectedLanguage = getLanguageFromUrl()

  const handleTagClick = (tagId: string) => {
    const tag = departmentRelatedTags.find((tag) => tag.id === tagId)
    if (tag) {
      setActiveTabId(tag.id)

      const allLinks = document.querySelectorAll('div[data-tags-ids]')

      allLinks.forEach((link) => {
        const dataTags = link.getAttribute('data-tags-ids')
        if (dataTags?.split(',').includes(tag.id)) {
          ;(link as HTMLElement).style.display = 'block'
        } else {
          ;(link as HTMLElement).style.display = 'none'
        }
      })
    }
  }

  useEffect(() => {
    if (!newsByTags && departmentDetails && departmentDetails.length) {
      const relatedTags = departmentDetails[0].relatedTags

      dispatch(getNewsByTags(relatedTags))
    }
  }, [departmentDetails, newsByTags])

  useEffect(() => {
    if (newsByTags) {
      const allLinks = document.querySelectorAll('div[data-tags-ids]')

      allLinks.forEach((link) => {
        const dataTags = link.getAttribute('data-tags-ids')
        if (dataTags?.split(',').includes(departmentRelatedTags[0].id)) {
          ;(link as HTMLElement).style.display = 'block'
        } else {
          ;(link as HTMLElement).style.display = 'none'
        }
      })
    }
  }, [newsByTags])

  useEffect(() => {
    if (!newsTags && departmentDetails && departmentDetails.length)
      dispatch(getNewsTags())
  }, [departmentDetails, newsTags])

  useEffect(() => {
    if (newsTags && departmentDetails && departmentDetails.length) {
      const relatedTags = departmentDetails[0].relatedTags
      const relatedTagsTemp: ITag[] = []

      for (let i = 0; i < relatedTags.length; i++) {
        const tag = newsTags.find((tag) => tag.id === relatedTags[i])

        if (tag) {
          relatedTagsTemp.push(tag)
        }
      }

      setDepartmentRelatedTags(relatedTagsTemp)
    }
  }, [newsTags])

  return {
    ...props,
    selectedLanguage,
    newsByTags,
    activeTabId,
    departmentRelatedTags,
    handleTagClick,
  }
}
